import { render, staticRenderFns } from "./UiSocials.vue?vue&type=template&id=22226066&scoped=true"
import script from "./UiSocials.vue?vue&type=script&lang=js"
export * from "./UiSocials.vue?vue&type=script&lang=js"
import style0 from "./UiSocials.vue?vue&type=style&index=0&id=22226066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22226066",
  null
  
)

export default component.exports